import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useStyles from './roundOutlineSVG.styles';
/* eslint no-tabs: ['error', { allowIndentationTabs: true }] */

const DEFAULT_ICON_SIZE = 53;
const BUTTON_BASE_WIDTH = 192;

const RoundOutlineSVG = (props) => {
	const classes = useStyles();
	const {
		width,
		text,
        iconSize,
        onTextMatrixChange,
	} = props;
	const textRef = useRef();
	const [transformMatrix, setTransformMatrix] = useState('matrix(1 0 0 1 58.5319 28.4999)');

    useEffect(() => {
        onTextMatrixChange(transformMatrix);
    }, [transformMatrix]);

	useEffect(() => {
		if (textRef.current) {
			const text = textRef.current;
			const tbox = text.getBBox();
            // Note: Always use the iconSize as an offset to center things accordingly
			const newX = (iconSize / 2) + ((BUTTON_BASE_WIDTH - tbox.width) / 2);
			const translation = 'matrix(1 0 0 1 ' + newX + ' 28.4999)'; // will be sent to the backend as textMatrix
			setTransformMatrix(translation);
		}
	}, [textRef.current, width, text]);

	return (
		<svg
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            viewBox="0 0 202.6 48"
            style={{ enableBackground: 'new 0 0 202.6. 48' }}
            xmlSpace="preserve"
            xmlnsXlink='http://www.w3.org/1999/xlink'
            >
                <g>
	                <path className={classes.st0} d="M197.1,1c2.5,0,4.5,2.1,4.5,4.6v36.8c0,2.5-2,4.6-4.5,4.6H5.5C3,47,1,44.9,1,42.4V5.6C1,3.1,3,1,5.5,1H197.1
		 M197.1,0H5.5C2.5,0,0,2.5,0,5.6v36.8C0,45.5,2.5,48,5.5,48h191.6c3,0,5.5-2.5,5.5-5.6V5.6C202.6,2.5,200.1,0,197.1,0L197.1,0z"/>
                </g>

                <text
                    ref={textRef}
                    transform={transformMatrix}
                    className={classNames([classes.st0, classes.st1, classes.st2])}>
                        {text}
                </text>
                <defs>
                    <linearGradient id='monoLinear1' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(-103,0,-0,-178.01613,164,57.752659)'>
                        <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
                        <stop offset='0.48' style={{ stopColor: 'white', stopOpacity: 0.51 }} />
                        <stop offset='1' style={{ stopColor: 'white', stopOpacity: 0 }} />
                    </linearGradient>
                    <linearGradient id='monoLinear2' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(104.098721,0,0,161.004363,59.901279,54.62662)'>
                        <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
                        <stop offset='0.48' style={{ stopColor: 'white', stopOpacity: 0.51 }} />
                        <stop offset='1' style={{ stopColor: 'white', stopOpacity: 0 }} />
                    </linearGradient>
                    <linearGradient id='monoLinear3' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(-103,0,-0,-178.785995,164,57.752659)'>
                        <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
                        <stop offset='0.48' style={{ stopColor: 'white', stopOpacity: 0.51 }} />
                        <stop offset='1' style={{ stopColor: 'white', stopOpacity: 0 }} />
                    </linearGradient>
                </defs>
                <g transform='translate(6 14.5) scale(0.22)'>
                    <g transform='translate(-287.009995 -55.65802)'>
                        <g transform='translate(263 3)'>
                            <g transform='matrix(1.027215,0,0,0.594346,-23.804988,100.522251)'>
                                <path d='M164,57.753C164,73.07 156.805,85.505 147.942,85.505L77.058,85.505C68.195,85.505 61,73.07 61,57.753C61,42.436 68.195,30 77.058,30L147.942,30C156.805,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear1)' }} />
                            </g>
                        </g>
                        <g transform='translate(263 3)'>
                            <g transform='matrix(0.919245,0,0,0.594346,-32.063975,67.532896)'>
                                <path d='M164,57.753C164,73.07 155.96,85.505 146.056,85.505L78.944,85.505C69.04,85.505 61,73.07 61,57.753C61,42.436 69.04,30 78.944,30L146.056,30C155.96,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear2)' }} />
                            </g>
                        </g>
                        <g transform='translate(263 3)'>
                            <g transform='matrix(1.027215,0,0,0.591787,-4.463251,34.904425)'>
                                <path d='M164,57.753C164,73.07 156.836,85.505 148.011,85.505L76.989,85.505C68.164,85.505 61,73.07 61,57.753C61,42.436 68.164,30 76.989,30L148.011,30C156.836,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear3)' }} />
                            </g>
                        </g>
                    </g>
                </g>
                <line className={classes.st4} x1="43.5" y1="1" x2="43.5" y2="47"/>
        </svg>
	);
};

RoundOutlineSVG.propTypes = {
	width: PropTypes.number,
	text: PropTypes.string,
	iconSize: PropTypes.number,
    onTextMatrixChange: PropTypes.func,
};

RoundOutlineSVG.defaultProps = {
	width: 200,
	text: 'Sync to Calendar',
	iconSize: DEFAULT_ICON_SIZE,
    onTextMatrixChange: () => {},
};

export default RoundOutlineSVG;
